import React from 'react';
import { SITE_CONFIG } from '../config';

// FMLS-required IDX disclosures, mirrored from the fleet reference implementation:
// - preview: list previews and search results
// - detail: detailed listing views, including copyright and data-last-updated time
const MlsDisclosure = ({ variant = 'preview', updatedAt = null, showLicenses = false }) => {
  const mls = SITE_CONFIG.MLS;
  const year = new Date().getFullYear();

  return (
    <>
      {variant === 'detail' ? mls.DISCLAIMER_DETAIL : mls.DISCLAIMER_PREVIEW}{' '}
      If you believe any FMLS Listing contains material that infringes your copyrighted work, please{' '}
      <a href={mls.DMCA_URL} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
        click here
      </a>{' '}
      to review our DMCA policy and learn how to submit a takedown request. © {variant === 'detail' ? `${year} ` : ''}FMLS.
      {updatedAt ? ` Data Last Updated: ${new Date(updatedAt).toLocaleString()}.` : ''}
      {showLicenses ? ` | Brokerage License: ${SITE_CONFIG.AGENT.BROKERAGE_LICENSE} | Agent License: ${SITE_CONFIG.AGENT.LICENSE}` : ''}
    </>
  );
};

export default MlsDisclosure;
